import FormattedMessage from 'I18n/components/FormattedMessage';
import { MODAL_TYPES } from 'web-interactives-dashboard-ui/constants/ModalConstants';
import withModalProps from 'web-interactives-dashboard-ui/hoc/withModalProps';
import { useDispatch } from 'react-redux';
import { unpublishInteractive } from '../../actions/InteractivesActions';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const UnpublishModal = ({
  onClose,
  interactiveId
}) => {
  const dispatch = useDispatch();
  const onConfirm = id => {
    dispatch(unpublishInteractive(id));
  };
  return /*#__PURE__*/_jsx(ConfirmModal, {
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `manage.modals.unpublish.confirm`
    }),
    confirmUse: "danger",
    "data-test-id": "unpublish-modal",
    description: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `manage.modals.unpublish.message`
      })
    }),
    message: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `manage.modals.unpublish.title`
      })
    }),
    onConfirm: () => onConfirm(interactiveId),
    onReject: onClose,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "manage.modals.unpublish.cancel"
    }),
    size: "auto"
  });
};
export default withModalProps(UnpublishModal, MODAL_TYPES.UNPUBLISH);